import { TeamMember, Service } from "@/lib/index";
import { IMAGES } from "@/assets/images";

export const teamMembers: TeamMember[] = [
  {
    id: "leo-moozhil",
    name: "Leo Moozhil",
    title: "Managing Director & Head of Canada Business",
    company: "15771455 Canada Inc",
    location: "Bridgewater, Ontario",
    experience: "20+ years",
    description: "Seasoned executive with over 20 years of experience in sales, technology, and business development. Leo leads ALTCloud Canada's strategic vision and growth initiatives, bringing deep expertise in enterprise technology solutions and client relationship management.",
    image: IMAGES.LG_2_63,
  },
  {
    id: "rahul-shenoy",
    name: "Rahul Shenoy",
    title: "Business Development Director",
    location: "Greater Toronto Area",
    experience: "15+ years",
    description: "Dynamic business development leader with extensive construction and marine engineering technologies background and 15+ years of cross-industry experience. Rahul drives strategic partnerships and market expansion, leveraging his unique technical expertise to deliver innovative AI-led solutions.",
    image: IMAGES.RS_2_65,
  },
  {
    id: "bhawesh-c",
    name: "Bhawesh C",
    title: "Head of Delivery & Operations",
    location: "Greater Toronto Area",
    experience: "25+ years",
    description: "Veteran IT operations executive with 25+ years of experience working with large Global System Integrators (GSIs). Bhawesh ensures operational excellence and seamless delivery of AI-powered IT services, bringing world-class standards to every client engagement.",
    image: IMAGES.BC_2_66,
  },
];

export const services: Service[] = [
  {
    id: "ai-consulting",
    title: "AI Consulting & Strategy",
    description: "Transform your business with AI-powered insights and strategic roadmaps tailored to your industry.",
    icon: "brain",
    features: [
      "AI readiness assessment",
      "Custom AI strategy development",
      "Machine learning implementation",
      "AI ethics and governance",
    ],
  },
  {
    id: "cloud-transformation",
    title: "Cloud Transformation",
    description: "Migrate and optimize your infrastructure with enterprise-grade cloud solutions.",
    icon: "cloud",
    features: [
      "Multi-cloud architecture design",
      "Cloud migration services",
      "Infrastructure optimization",
      "Cost management and FinOps",
    ],
  },
  {
    id: "cybersecurity",
    title: "Cybersecurity Solutions",
    description: "Protect your digital assets with AI-enhanced security frameworks and threat detection.",
    icon: "shield",
    features: [
      "AI-powered threat detection",
      "Security architecture design",
      "Compliance and risk management",
      "24/7 security monitoring",
    ],
  },
  {
    id: "data-analytics",
    title: "Data Analytics & Intelligence",
    description: "Unlock actionable insights from your data with advanced analytics and AI-driven intelligence.",
    icon: "chart",
    features: [
      "Big data platform development",
      "Predictive analytics",
      "Real-time data processing",
      "Business intelligence dashboards",
    ],
  },
  {
    id: "automation",
    title: "Intelligent Automation",
    description: "Streamline operations and boost efficiency with AI-powered automation solutions.",
    icon: "automation",
    features: [
      "Robotic process automation (RPA)",
      "Workflow optimization",
      "AI-driven decision automation",
      "Integration with legacy systems",
    ],
  },
  {
    id: "managed-services",
    title: "Managed IT Services",
    description: "Focus on your core business while we manage your IT infrastructure with AI-enhanced monitoring.",
    icon: "settings",
    features: [
      "24/7 infrastructure monitoring",
      "Proactive maintenance",
      "Help desk and support",
      "Performance optimization",
    ],
  },
];

export const companyInfo = {
  name: "ALTCloud Canada",
  tagline: "AI-Led IT Services for the Future",
  description: "ALTCloud Canada is a leading provider of AI-powered IT services, delivering cutting-edge technology solutions to businesses across Canada. With over 60 years of combined leadership experience, we specialize in cloud transformation, cybersecurity, data analytics, and intelligent automation.",
  email: "reach@altcloudai.com",

  address: {
    city: "Toronto",
    province: "Ontario",
    country: "Canada",
  },
  founded: "2026",
  mission: "To empower businesses with AI-led technology solutions that drive innovation, efficiency, and sustainable growth.",
  vision: "To be Canada's most trusted partner in AI-powered digital transformation, setting new standards for excellence in IT services.",
  values: [
    "Innovation: Embracing cutting-edge AI and cloud technologies",
    "Excellence: Delivering world-class service quality",
    "Integrity: Building trust through transparency and ethics",
    "Collaboration: Partnering with clients for mutual success",
  ],
};
